export default function Spinner({ position = "fixed", type = "" }) {
  if (type === "file_upload") {
    return (
      <div
        style={{ position }}
        className={`spinner upload ${
          position === "absolute" ? "imgChange" : ""
        }`}
      >
        <div />
        {/* <small>잠시만 기다려 주세요</small> */}
      </div>
    );
  }

  return (
    <div
      style={{ position }}
      className={`spinner ${position === "absolute" ? "imgChange" : ""} ${type === "report" ? "report" : ""} `}
    >
      <div />
    </div>
  );
}
